<template>
  <!-- paywall -->
  <div
    v-if="showPaywall"
    :class="showPaywall ? 'select-none paywall-gate rounded-md absolute bg-opacity-30 inset-0 z-10 p-6 flex flex-col items-center justify-center size-full text-center' : 'hidden'"
    @mouseover="startJiggle"
    @mouseleave="stopJiggle"
  >
    <div
      v-if="showLockIcon"
      class="paywall-lock-icon mb-6 text-inverse rounded-full size-12 flex flex-col items-center justify-center"
      :class="{ 'animate-jiggle': isJiggling }"
    >
      <AM3Icon
        type="lock-closed"
        size="lg"
      />
    </div>

    <p
      class="text-xl mb-1 font-medium"
      style="text-shadow: 1px 1px 2px #fff;"
    >
      {{ title }}
    </p>
    <p class="text-sm mb-6">
      {{ description }}
    </p>

    <AM3Button
      :text="buttonText"
      type="gradient"
      icon-left="rocket-launch"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AM3Button from '@/components/am3-generic/base/AM3Button.vue'
import AM3Icon from '@/components/am3-generic/base/icon/AM3Icon.vue'

interface Props {
  showLockIcon?: boolean
  showPaywall?: boolean
  title?: string
  description?: string
  buttonText?: string
  buttonIcon?: string
}

withDefaults(defineProps<Props>(), {
  showLockIcon: true,
  showPaywall: false,
  title: 'Unlock website activity tracking',
  description: 'Track website activity to create segments & automations based on how people engage with your website.',
  buttonText: 'Upgrade Plan',
  buttonIcon: 'rocket',
})

const isJiggling = ref(false)
let timeout: ReturnType<typeof setTimeout> | null = null

function startJiggle() {
  if (timeout) clearTimeout(timeout)
  isJiggling.value = true
  timeout = setTimeout(() => {
    isJiggling.value = false
  }, 300)
}

function stopJiggle() {
  if (timeout) clearTimeout(timeout)
  isJiggling.value = false
}
</script>

<style scoped>
@keyframes jiggle {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(5deg); }
  75% { transform: rotate(-5deg); }
}

.animate-jiggle {
  animation: jiggle 0.3s ease-in-out;
}

.paywall-gate {
  background: rgba( 255,255,255 , 0.3);
  backdrop-filter: blur(8px) ;
}

.paywall-lock-icon {
  background:
    linear-gradient(90deg, #9333EA, #DE5BEC),
    linear-gradient(90deg, #B758F6 0%, #DE5BEC 100%)
  ;
  box-shadow: 0px 0px 10px 2px #9333EA4D;
}

/* specific firefox rule to make more opaque - their support for bg blur is not great, so this will help */
@-moz-document url-prefix() {
  .paywall-gate {
    background: rgba( 255,255,255 , 0.45);
  }
}
</style>
